import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BackButton = ({ fallbackTo, context }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    const returnTo = location.state?.returnTo || fallbackTo;
    const historyIndex = window.history.state?.idx;

    if (typeof historyIndex === 'number' && historyIndex > 0) {
      navigate(-1);
      return;
    }

    if (returnTo) {
      navigate(returnTo, { replace: true });
    }
  };

  return (
    <button type="button" className="back-button" onClick={handleBack}>
      <span className="icon-chevron-left" /> {t('common-back')}
      {context ? ` / ${context}` : ''}
    </button>
  );
};

export default BackButton;
